import { FilterTable } from "@/features/FilterTable/FilterTable";
import { Field } from "@/features/FilterTable/types";
import { z } from "zod";

import useDateOptions from "@/features/FilterTable/useDateOptions";

const filterA7OPCVMIssuerTSSchema = z.object({
  date_equals: z.string().optional(),
  denomination_du_sous_jacent_contains: z.string().optional(),
});

export type FilterA7OPCVMIssuerTSSchema = z.infer<
  typeof filterA7OPCVMIssuerTSSchema
>;

const initialFields: Field[] = [
  {
    name: "date_equals",
    label: `Date`,
    type: "autocomplete",
    options: [],
  },
  {
    name: "denomination_du_sous_jacent_contains",
    label: `Émetteur`,
    type: "input",
  },
];

export function FilterA7OPCVMIssuerTS({ table_name }: { table_name: string }) {
  const { fields } = useDateOptions("a7", table_name, initialFields);

  return (
    <FilterTable
      client="a7"
      schema={filterA7OPCVMIssuerTSSchema}
      tableName="a7_opcvm_issuer_ts"
      fields={fields}
      customBuildPath={() => `a7-opcvm/${table_name}`}
      excludeFieldsFromConvertDate={["date_equals"]}
    />
  );
}
